import { createClient } from '@supabase/supabase-js';

const rawSupabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const rawSupabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

/**
 * Netlify/env kopyalama hatalarında URL içindeki tüm boşlukları temizler.
 * Örn: "https://xxx.supabase.co   " → punycode hatasına yol açar (ERR_NAME_NOT_RESOLVED).
 */
export const normalizeSupabaseUrl = (url) => {
    if (!url) return null;

    let cleaned = String(url).replace(/\s+/g, '');
    cleaned = cleaned.replace(/\/rest\/v1\/?$/i, '').replace(/\/+$/, '');

    if (!/^https?:\/\//i.test(cleaned)) {
        cleaned = `https://${cleaned}`;
    }

    try {
        const parsed = new URL(cleaned);
        if (!/\.supabase\.co$/i.test(parsed.hostname)) {
            return null;
        }
        return `${parsed.protocol}//${parsed.hostname}`;
    } catch {
        return null;
    }
};

const normalizeSupabaseAnonKey = (key) => {
    if (!key) return null;
    return String(key).replace(/\s+/g, '').trim() || null;
};

const supabaseUrl = normalizeSupabaseUrl(rawSupabaseUrl);
const supabaseAnonKey = normalizeSupabaseAnonKey(rawSupabaseAnonKey);

/**
 * Supabase istemcisi - yalnızca Anon Key kullanır.
 * Service Role Key frontend'e ASLA eklenmemelidir.
 */
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isSupabaseConfigured
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true
        }
    })
    : null;

export const getSupabaseConnectionHint = () => {
    if (isSupabaseConfigured) return null;
    if (rawSupabaseUrl && !supabaseUrl) {
        return 'Supabase URL geçersiz. Netlify ortam değişkeninde REACT_APP_SUPABASE_URL değerini kontrol edin (boşluksuz: https://PROJE_ID.supabase.co).';
    }
    if (!rawSupabaseUrl || !rawSupabaseAnonKey) {
        return 'Supabase yapılandırması eksik. Netlify\'da REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY tanımlı olmalı.';
    }
    return 'Supabase bağlantı ayarları hatalı.';
};

export default supabase;
